import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title"];
var IconHomeSolid = function IconHomeSolid(_ref) {
  var title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-home-solid"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "m21.53 9.49-9.06-7.33A.7.7 0 0 0 12 2a.7.7 0 0 0-.47.16L2.47 9.49c-.26.2-.47.65-.47.98V21.4c0 .33.27.6.6.6h7.05a.6.6 0 0 0 .6-.6v-4.87c0-.33.27-.6.6-.6h2.3c.33 0 .6.27.6.6v4.87c0 .33.27.6.6.6h7.05a.6.6 0 0 0 .6-.6V10.47c0-.33-.21-.77-.47-.98"
  }));
};
IconHomeSolid.displayName = 'InlineIcon(IconHomeSolid)';
IconHomeSolid.propTypes = {
  title: PropTypes__default.string
};

export { IconHomeSolid };
